module.exports = __webpack_public_path__ + "img/img004.3141b1b0.png";